import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useToast } from "@finitless/shared/hooks";
import { deleteMetaAdsAdSet } from "./useMetaAdsApi";

const GRAPH_CAMPAIGNS_KEY = ["meta-ads-graph-campaigns"];

function stripAdSetFromGraphCampaignsPayload(data, adSetId) {
  const id = String(adSetId ?? "").trim();
  if (!data || typeof data !== "object" || !Array.isArray(data.adSets)) {
    return data;
  }
  const adSets = data.adSets.filter(
    (adSet) => String(adSet?.adSetId ?? "") !== id,
  );
  if (adSets.length === data.adSets.length) {
    return data;
  }
  const ads = Array.isArray(data.ads)
    ? data.ads.filter((ad) => String(ad?.adSetId ?? "") !== id)
    : data.ads;
  return { ...data, adSets, ads };
}

export function useMetaAdsDeleteAdSet() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  const { t } = useTranslation("metaAds");

  return useMutation({
    mutationFn: async ({ adSetId }) => {
      await deleteMetaAdsAdSet(adSetId);
      return { adSetId: String(adSetId ?? "").trim() };
    },

    onError: (err) => {
      showToast(err?.message || t("create.deleteAdSetErrorToast"), "error");
    },

    onSuccess: (_data, variables) => {
      const id = String(variables?.adSetId ?? "").trim();
      if (id) {
        queryClient.removeQueries({
          queryKey: ["meta-ads-adset-detail", id],
          exact: true,
        });
        queryClient.setQueriesData(
          { queryKey: GRAPH_CAMPAIGNS_KEY, exact: false },
          (old) => stripAdSetFromGraphCampaignsPayload(old, id),
        );
      }
      showToast(t("create.deleteAdSetSuccessToast"), "success");
    },
  });
}
